// extracted by mini-css-extract-plugin
module.exports = {"signInForm":"signInForm__3fVz8","formElement":"formElement__2VYgC","forgotPassword":"forgotPassword__3ZQ60","submitButton":"submitButton__2oVwv"};